<!-- Add Edit users modal. -->
<div class="modal-content">

  <!-- Modal Header -->
  <div class="modal-header">
    Save Cropped Image
    <i class="material-icons" (click)="closeSelectionModal()">close</i>
  </div>

  <div class="modal-body nopadding b-height bodyDisplay">
    <div class="col-md-10 content-container margin-text">
      <span>Reposition and zoom the image below to select a portion for the banner image of the challenge.</span>
    </div>
    <div class="col-md-10">
      <div class="img-component">
        <img class="img-responsive" style="width: 100% !important;" src="assets/img/NoImage.png" alt="No Image"
          id="uploadedImage" />
      </div>
    </div>
    <div class="col-md-10 content-container">
      <span class="material-icons-outlined mar-right  cursor-pointer">
        zoom_out
      </span>
      <ngx-slider [(value)]="value" [options]="options" (valueChange)="zoomImg($event)"></ngx-slider>
      <span class="material-icons-outlined mar-left  cursor-pointer">
        zoom_in
      </span>
    </div>
  </div>
  <input type="hidden" value="" id="position-x" />
  <input type="hidden" value="" id="position-y" />
  <input type="hidden" value="" id="cropper-height" />
  <input type="hidden" value="" id="cropper-width" />
  <div class="modal-footer">
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default"
      (click)='closeSelectionModal()'>Cancel</button>
    <button type="button" class="btn btn__btn-default btn__orange" (click)="saveChallengeImage()">Save Image</button>
  </div>
</div>
<!-- End -->
